













import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'Pagination'
})
export default class extends Vue {
  @Prop({ default: 1 }) currentPage!: number
  @Prop({ default: 10 }) pageSize!: number
  @Prop() total!: number

  private handleSizeChange(val: number) {
    this.$emit('onsbumit', 1, val)
  }

  private handleCurrentChange(val: number) {
    this.$emit('onsbumit', val, this.pageSize)
  }
}
